export const DocumentManagementRoutes = {
    AddDocumentRequirements: 'add-document-requirements',
    ManageDocumentRequirements: "manage-document-requirements",
    DocumentRequirementsOverview: "document-requirements-overview",
}